import { Id, TextareaField } from "@dgs/core";
import { ReactNode } from "react";
import { DataFieldIndexResource } from "../../types/dataField";
import {
	ContactAttributeRequest,
	IContactAttributeBaseHandler,
	IContactAttributeHandler,
	IContactAttributeListHandler,
} from "../IContactAttributeHandler";

export function createLongTextDataFieldContactAttributeBaseHandler(
	id: Id,
	dataField: DataFieldIndexResource,
): IContactAttributeBaseHandler {
	return {
		type: "LONG_TEXT_DATA_FIELD",
		id,
		getLabel: () => dataField.label,
	};
}

export function createLongTextDataFieldContactAttributeProfileHandler(
	id: Id,
	value: string | null,
	dataField: DataFieldIndexResource,
): IContactAttributeHandler<string, string | null> {
	const baseHandler = createLongTextDataFieldContactAttributeBaseHandler(id, dataField);
	return {
		...baseHandler,
		value,
		validate() {
			return null;
		},
		renderValue(): ReactNode {
			return this.value ?? "";
		},
		renderFormField(t, prefix): ReactNode {
			return (
				<TextareaField
					name={`${prefix ? `${prefix}.` : ""}${id}.value`}
					label={baseHandler.getLabel(t)}
					placeholder={dataField.placeholder}
					description={dataField.description}
				/>
			);
		},
		toRequestValue(): ContactAttributeRequest<string> {
			return { id, value: this.value ?? "" };
		},
	};
}

export function createLongTextDataFieldContactAttributeListHandler(
	id: Id,
	dataField: DataFieldIndexResource,
): IContactAttributeListHandler {
	const baseHandler = createLongTextDataFieldContactAttributeBaseHandler(id, dataField);
	return {
		...baseHandler,
		getColumnSize: () => "2fr",
	};
}
